const routes = {
    // home: "/",

    menu: "/",
    location: "/location",
    booking: "/booking",
    news: "/news",
    recruit: "/recruit",
    delivery: "/delivery",
};
  
export default routes;
